import { useState, useEffect } from 'react';
import Layout from '@/components/feature/Layout';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function About() {
  const [formError, setFormError] = useState('');
  const [formSuccess, setFormSuccess] = useState('');

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormError('');
    setFormSuccess('');

    const form = e.currentTarget;
    const honeypot = (form.querySelector('[name="phone_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setFormSuccess('您的留言已成功提交，我们会尽快与您联系！');
      form.reset();
      return;
    }

    try {
      const formData = new FormData(form);
      const response = await fetch('https://readdy.ai/api/form/d9sqhcllbrt1qcgaj8bg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;

      if (response.ok && parsed?.code === 'OK') {
        setFormSuccess('您的留言已成功提交，我们会尽快与您联系！');
        form.reset();
      } else {
        const isSpam = typeof serverMsg === 'string' && serverMsg.toLowerCase().includes('spam');
        if (isSpam) {
          setFormError('提交失败，请稍后重试。');
        } else {
          setFormError(typeof serverMsg === 'string' ? serverMsg : '提交失败，请稍后重试。');
        }
      }
    } catch {
      setFormError('网络错误，请稍后重试。');
    }
  };

  const aboutSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于PG国际下载008',
    description: 'PG国际下载008官方正版下载平台品牌介绍、信誉展示与联系方式',
    url: 'https://pgjixz008.com/about',
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'PG国际下载008',
    url: 'https://pgjixz008.com/',
    description: 'PG国际下载008官方正版，提供最新版本极速安装包，支持iOS与Android全平台下载。',
    email: 'service@pgjixz008.com',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'service@pgjixz008.com',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
  };

  return (
    <Layout>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(aboutSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <Breadcrumb
        items={[
          { label: '首页', path: '/' },
          { label: '关于我们' },
        ]}
      />

      {/* Brand Intro */}
      <section className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-4">
            关于 PG国际下载008
          </h1>
          <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-2xl mx-auto mb-6">
            PG国际下载008是PG国际平台官方指定的正版下载渠道，致力于为全球玩家提供安全、便捷、极速的PG国际008安装包下载服务。
            我们始终坚持"安全第一、用户至上"的理念，通过严格的安全检测机制确保每一个安装包的安全可靠。
          </p>
          <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-2xl mx-auto">
            PG国际008平台汇聚了老虎机、棋牌、捕鱼、体育竞猜、彩票等上百款精品游戏，
            覆盖iOS与Android全平台，让玩家随时随地畅享精彩的游戏体验。
            我们的团队由资深游戏行业专家组成，持续优化产品体验，为玩家提供最优质的服务。
          </p>
        </div>
      </section>

      {/* Reputation */}
      <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center mb-10">
            品牌信誉
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {[
              {
                icon: 'ri-shield-star-line',
                title: '官方认证',
                desc: 'PG国际平台官方授权下载渠道，品牌信誉有保障，值得信赖。',
              },
              {
                icon: 'ri-user-heart-line',
                title: '500万+用户',
                desc: '全球超过500万玩家选择PG国际008，用户口碑见证品牌实力。',
              },
              {
                icon: 'ri-secure-payment-line',
                title: '安全可靠',
                desc: '银行级加密技术保障，通过国际安全认证，全流程保护用户数据。',
              },
              {
                icon: 'ri-award-line',
                title: '行业标杆',
                desc: '连续三年荣获行业最佳游戏平台奖项，品质与服务的双重认可。',
              },
            ].map((item, index) => (
              <div
                key={index}
                className="p-6 rounded-xl bg-background-50 border border-background-200/70 text-center"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100/80 text-accent-600 mx-auto mb-4">
                  <i className={`${item.icon} text-xl`}></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-950 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact */}
      <section className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center mb-10">
            联系我们
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-8">
            <div className="lg:col-span-2 flex flex-col gap-5">
              {[
                {
                  icon: 'ri-mail-line',
                  title: '客服邮箱',
                  content: 'service@pgjixz008.com',
                },
                {
                  icon: 'ri-customer-service-2-line',
                  title: '在线客服',
                  content: '7×24小时全天候在线服务',
                },
                {
                  icon: 'ri-wechat-line',
                  title: '微信公众号',
                  content: '搜索关注 "PG国际008官方"',
                },
                {
                  icon: 'ri-time-line',
                  title: '响应时间',
                  content: '客服团队承诺3分钟内快速响应',
                },
              ].map((item, index) => (
                <div
                  key={index}
                  className="flex items-start gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70"
                >
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100/80 text-primary-600 flex-shrink-0">
                    <i className={`${item.icon} text-lg`}></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-950 mb-1">{item.title}</h3>
                    <p className="text-sm text-foreground-500">{item.content}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="lg:col-span-3">
              <div className="p-6 md:p-8 rounded-xl bg-background-50 border border-background-200/70">
                <h3 className="text-lg font-semibold text-foreground-950 mb-6">发送留言</h3>
                <form
                  data-readdy-form
                  onSubmit={handleSubmit}
                  className="flex flex-col gap-4"
                >
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <div>
                      <label htmlFor="name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                        姓名 *
                      </label>
                      <input
                        type="text"
                        id="name"
                        name="name"
                        required
                        className="w-full px-4 py-2.5 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-950 focus:outline-none focus:border-primary-300 transition-colors"
                        placeholder="请输入您的姓名"
                      />
                    </div>
                    <div>
                      <label htmlFor="email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                        邮箱 *
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        required
                        className="w-full px-4 py-2.5 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-950 focus:outline-none focus:border-primary-300 transition-colors"
                        placeholder="请输入您的邮箱"
                      />
                    </div>
                  </div>
                  <div>
                    <label htmlFor="subject" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      主题 *
                    </label>
                    <input
                      type="text"
                      id="subject"
                      name="subject"
                      required
                      className="w-full px-4 py-2.5 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-950 focus:outline-none focus:border-primary-300 transition-colors"
                      placeholder="请输入留言主题"
                    />
                  </div>
                  <div>
                    <label htmlFor="message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                      留言内容 *
                    </label>
                    <textarea
                      id="message"
                      name="message"
                      required
                      maxLength={500}
                      rows={5}
                      className="w-full px-4 py-2.5 rounded-lg border border-background-200/70 bg-background-50 text-sm text-foreground-950 focus:outline-none focus:border-primary-300 transition-colors resize-none"
                      placeholder="请输入您的留言内容（500字以内）"
                    ></textarea>
                  </div>
                  <input
                    type="text"
                    name="phone_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="honeypot-field"
                  />
                  {formError && (
                    <p className="text-sm text-red-600">{formError}</p>
                  )}
                  {formSuccess && (
                    <p className="text-sm text-accent-700">{formSuccess}</p>
                  )}
                  <button
                    type="submit"
                    className="w-full sm:w-auto self-start px-8 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    发送留言
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}